// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern Hero Slideshow Styles */

:root {
  --primary-color: #2a9d8f;
  --primary-dark: #1e6e64;
  --primary-light: #8ecec3;
  --secondary-color: #dcca98;
  --secondary-dark: #b8a87d;
  --secondary-light: #e5d8b7;
  --text-dark: #264653;
  --text-light: #dcca98;
  --background-light: #f8f9fa;
  --background-dark: transparent;
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

body {
  margin: 0;
  padding: 0;
}

.hero-slideshow {
  position: relative;
  width: 100%;
  height: 650px;
  overflow: hidden;
  background: transparent;
}

.gradient-bg {
  position: absolute;
  inset: 0;
  background: transparent;
  z-index: -2;
}

.radial-overlay {
  position: absolute;
  inset: 0;
  background-image: radial-gradient(circle at top right, rgba(255, 255, 255, 0.1), transparent 70%);
  z-index: -1;
}

.slideshow-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: transparent;
}

.slides-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  transition: transform 0.5s ease;
  background-color: transparent;
}

.slide {
  min-width: 100%;
  height: 100%;
  background-color: transparent;
}

.slide.active {
  animation: fadeIn 0.5s ease forwards;
}

.hero-slide {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 24px;
  background-color: transparent;
}

.hero-container {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  background-color: transparent;
}

/* Grid Layout */
.hero-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  align-items: center;
  background-color: transparent;
}

/* Content Styles */
.hero-content {
  margin-bottom: 40px;
  animation: fadeSlideUp 0.5s ease forwards;
  opacity: 0;
  transform: translateY(20px);
  background-color: transparent;
}

.hero-heading {
  font-size: 3.75rem;
  font-weight: 800;
  color: white;
  margin-bottom: 24px;
  line-height: 1.1;
  max-width: 650px;
  letter-spacing: -0.5px;
  text-align: left;
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.3),
               0 0 20px rgba(255, 255, 255, 0.2),
               0 0 30px rgba(255, 255, 255, 0.1);
}

.hero-subheading {
  font-size: 1.8rem;
  color: var(--secondary-color);
  line-height: 1.5;
  max-width: 550px;
  font-weight: 500;
  text-align: left;
  margin-top: 1rem;
}

/* Button Styles */
.hero-button {
  background: linear-gradient(135deg, var(--secondary-color), var(--secondary-light));
  color: var(--primary-dark);
  font-size: 1.5rem;
  font-weight: 700;
  padding: 18px 36px;
  border-radius: 9999px;
  border: none;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  animation: fadeSlideUp 0.5s ease forwards,
             pulse 2s infinite;
  opacity: 0;
  box-shadow: 0 0 20px rgba(220, 202, 152, 0.3),
              0 0 40px rgba(220, 202, 152, 0.1);
  position: relative;
  overflow: hidden;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.hero-button::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(
    45deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
  transform: rotate(45deg);
  animation: shimmer 3s infinite;
}

.hero-button:hover {
  background: linear-gradient(135deg, var(--secondary-light), var(--secondary-color));
  transform: translateY(-3px) scale(1.05);
  box-shadow: 0 0 30px rgba(220, 202, 152, 0.4),
              0 0 60px rgba(220, 202, 152, 0.2);
}

.hero-button:active {
  transform: translateY(1px) scale(0.98);
}

.arrow-icon {
  margin-left: 12px;
  font-size: 1.8rem;
  transition: transform 0.3s ease;
}

.hero-button:hover .arrow-icon {
  transform: translateX(5px);
}

@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 20px rgba(220, 202, 152, 0.3),
                0 0 40px rgba(220, 202, 152, 0.1);
  }
  50% {
    transform: scale(1.03);
    box-shadow: 0 0 25px rgba(220, 202, 152, 0.4),
                0 0 50px rgba(220, 202, 152, 0.2);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 20px rgba(220, 202, 152, 0.3),
                0 0 40px rgba(220, 202, 152, 0.1);
  }
}

@keyframes shimmer {
  0% {
    transform: translate(-50%, -50%) rotate(45deg);
  }
  100% {
    transform: translate(150%, 150%) rotate(45deg);
  }
}

/* Image Content */
.hero-image-content {
  position: relative;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: fadeSlideUp 0.5s ease forwards;
  animation-delay: 0.1s;
  opacity: 0;
  background-color: transparent;
}

.gradient-shape {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(220, 202, 152, 0.15);
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  box-shadow: var(--shadow-lg);
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
  border: 1px solid rgba(220, 202, 152, 0.3);
}

.hero-svg {
  width: 100%;
  height: 100%;
  color: rgba(220, 202, 152, 0.2);
}

/* Membership card container styles */
.membership-card-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;
  background-color: transparent;
}

.membership-card-container .school-membership-card {
  width: 100%;
  margin-top: 0;
  max-width: 100%;
  box-shadow: var(--shadow-lg);
  border: 1px solid rgba(255, 255, 255, 0.3);
  animation: fadeIn 0.5s ease forwards;
  animation-delay: 0.1s;
}

/* School Membership Card */
.school-membership-card {
  background: linear-gradient(135deg, rgba(42, 157, 143, 0.85), rgba(30, 110, 100, 0.85));
  border-radius: 12px;
  padding: 0 40px 40px 40px;
  box-shadow: 0 8px 32px rgba(42, 157, 143, 0.3);
  margin-top: 30px;
  max-width: 550px;
  animation: fadeSlideUp 0.5s ease forwards;
  animation-delay: 0.3s;
  opacity: 0;
  border: 1px solid rgba(220, 202, 152, 0.3);
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
  position: relative;
  overflow: hidden;
}

.school-membership-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.1), transparent);
  animation: shimmer 2s infinite;
}

.membership-title {
  color: var(--secondary-color);
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 30px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.membership-footer {
  color: #e5d8b7;
  font-size: 2.5rem;
  font-weight: 700;
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.4),
               0 0 20px rgba(255, 255, 255, 0.2),
               0 0 30px rgba(255, 255, 255, 0.1);
  text-align: center;
  margin: 0 auto 0;
  animation: glow 2s ease-in-out infinite alternate;
}

@keyframes glow {
  from {
    text-shadow: 0 0 10px rgba(255, 255, 255, 0.4),
                 0 0 20px rgba(255, 255, 255, 0.2),
                 0 0 30px rgba(255, 255, 255, 0.1);
  }
  to {
    text-shadow: 0 0 20px rgba(255, 255, 255, 0.6),
                 0 0 30px rgba(255, 255, 255, 0.4),
                 0 0 40px rgba(255, 255, 255, 0.2);
  }
}

.benefits-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.benefit-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 24px;
  font-size: 1.6rem;
  color: white;
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.4),
               0 0 20px rgba(255, 255, 255, 0.2);
  position: relative;
}

.check-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background-color: rgba(255, 255, 255, 0.25);
  border-radius: 9999px;
  color: white;
  margin-right: 16px;
  flex-shrink: 0;
  font-size: 1.4rem;
  box-shadow: 0 0 15px rgba(255, 255, 255, 0.2);
}

.benefit-text {
  line-height: 1.5;
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.4),
               0 0 20px rgba(255, 255, 255, 0.2);
  transition: text-shadow 0.3s ease;
  font-weight: 500;
}

.benefit-item:hover .benefit-text {
  text-shadow: 0 0 15px rgba(255, 255, 255, 0.5),
               0 0 25px rgba(255, 255, 255, 0.3);
}

/* Navigation Buttons */
.nav-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 48px;
  height: 48px;
  background-color: rgba(220, 202, 152, 0.9);
  border-radius: 9999px;
  border: 1px solid rgba(220, 202, 152, 0.3);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-dark);
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 10;
  box-shadow: var(--shadow-md);
}

.nav-button:hover {
  background-color: var(--secondary-color);
  transform: translateY(-50%) scale(1.05);
  box-shadow: var(--shadow-lg);
}

.nav-button.prev {
  left: 20px;
}

.nav-button.next {
  right: 20px;
}

.nav-button svg {
  width: 28px;
  height: 28px;
}

/* Dots Navigation */
.dots-container {
  position: absolute;
  bottom: 32px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  gap: 10px;
  background-color: transparent;
}

.dot {
  width: 12px;
  height: 12px;
  border-radius: 9999px;
  background-color: rgba(220, 202, 152, 0.3);
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
}

.dot.active {
  background-color: var(--secondary-color);
  transform: scale(1.2);
}

/* Animations */
@keyframes fadeSlideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Limited Time Offer Styles */
.limited-time-tag {
  position: absolute;
  top: 20px;
  right: -35px;
  background: var(--secondary-color);
  color: var(--primary-color);
  padding: 8px 40px;
  transform: rotate(45deg);
  font-weight: bold;
  font-size: 0.9rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.original-price {
  display: inline-block;
  color: var(--secondary-color);
  font-size: 1.2rem;
  text-decoration: line-through;
  opacity: 0.8;
  margin-left: 8px;
  position: relative;
}

.original-price::after {
  display: none;
}

/* Responsive styles */
@media (max-width: 1024px) {
  .hero-heading {
    font-size: 3rem;
  }
  
  .hero-subheading {
    font-size: 1.3rem;
  }
}

@media (max-width: 768px) {
  .hero-grid {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    gap: 20px;
  }
  .hero-image-content {
    margin-top: 20px;
  }
  .membership-card-container {
    max-width: 100%;
    margin: 0 auto;
  }
  .membership-card-container .school-membership-card {
    max-width: 100%;
  }
  .hero-heading {
    font-size: 2.2rem;
    max-width: 100%;
  }
  .hero-subheading {
    font-size: 1.2rem;
    max-width: 100%;
  }
  .hero-button {
    padding: 18px 28px;
    margin-bottom: 10px;
    font-size: 1.1rem;
  }
  .school-membership-card {
    padding: 20px;
  }
  .benefit-item {
    padding: 8px 0;
  }
  .hero-slideshow {
    height: 800px;
    padding-top: 80px;
  }
  .slide {
    padding-top: 80px;
  }
  .hero-slide {
    align-items: flex-start;
    padding-top: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/home/HeroSlideshow.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;EACE,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;EAC3B,8BAA8B;EAC9B,kFAAkF;EAClF,oFAAoF;AACtF;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,iGAAiG;EACjG,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,6BAA6B;AAC/B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,yCAAyC;EACzC,UAAU;EACV,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB;;gDAE8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,mFAAmF;EACnF,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB;8BAC4B;EAC5B,UAAU;EACV;+CAC6C;EAC7C,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,mFAAmF;EACnF,uCAAuC;EACvC;+CAC6C;AAC/C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,mBAAmB;IACnB;iDAC6C;EAC/C;EACA;IACE,sBAAsB;IACtB;iDAC6C;EAC/C;EACA;IACE,mBAAmB;IACnB;iDAC6C;EAC/C;AACF;;AAEA;EACE;IACE,8CAA8C;EAChD;EACA;IACE,8CAA8C;EAChD;AACF;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;EACzC,qBAAqB;EACrB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,kCAA0B;UAA1B,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,4BAA4B;EAC5B,0CAA0C;EAC1C,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,uFAAuF;EACvF,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;EAC9C,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,qBAAqB;EACrB,UAAU;EACV,0CAA0C;EAC1C,kCAA0B;UAA1B,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,sFAAsF;EACtF,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB;;gDAE8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE;IACE;;kDAE8C;EAChD;EACA;IACE;;kDAE8C;EAChD;AACF;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ;gDAC8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB;gDAC8C;EAC9C,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE;gDAC8C;AAChD;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,qBAAqB;EACrB,0CAA0C;EAC1C,kCAA0B;UAA1B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,0CAA0C;EAC1C,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,kCAAkC;EAClC,2BAA2B;EAC3B,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,iBAAiB;EACjB,yCAAyC;EACzC,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,iBAAiB;EACjB,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,6BAA6B;IAC7B,SAAS;EACX;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;IACvB,cAAc;EAChB;AACF","sourcesContent":["/* Modern Hero Slideshow Styles */\n\n:root {\n  --primary-color: #2a9d8f;\n  --primary-dark: #1e6e64;\n  --primary-light: #8ecec3;\n  --secondary-color: #dcca98;\n  --secondary-dark: #b8a87d;\n  --secondary-light: #e5d8b7;\n  --text-dark: #264653;\n  --text-light: #dcca98;\n  --background-light: #f8f9fa;\n  --background-dark: transparent;\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n}\n\n.hero-slideshow {\n  position: relative;\n  width: 100%;\n  height: 650px;\n  overflow: hidden;\n  background: transparent;\n}\n\n.gradient-bg {\n  position: absolute;\n  inset: 0;\n  background: transparent;\n  z-index: -2;\n}\n\n.radial-overlay {\n  position: absolute;\n  inset: 0;\n  background-image: radial-gradient(circle at top right, rgba(255, 255, 255, 0.1), transparent 70%);\n  z-index: -1;\n}\n\n.slideshow-container {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  background-color: transparent;\n}\n\n.slides-wrapper {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  transition: transform 0.5s ease;\n  background-color: transparent;\n}\n\n.slide {\n  min-width: 100%;\n  height: 100%;\n  background-color: transparent;\n}\n\n.slide.active {\n  animation: fadeIn 0.5s ease forwards;\n}\n\n.hero-slide {\n  position: relative;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  padding: 0 24px;\n  background-color: transparent;\n}\n\n.hero-container {\n  max-width: 1200px;\n  width: 100%;\n  margin: 0 auto;\n  background-color: transparent;\n}\n\n/* Grid Layout */\n.hero-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 40px;\n  align-items: center;\n  background-color: transparent;\n}\n\n/* Content Styles */\n.hero-content {\n  margin-bottom: 40px;\n  animation: fadeSlideUp 0.5s ease forwards;\n  opacity: 0;\n  transform: translateY(20px);\n  background-color: transparent;\n}\n\n.hero-heading {\n  font-size: 3.75rem;\n  font-weight: 800;\n  color: white;\n  margin-bottom: 24px;\n  line-height: 1.1;\n  max-width: 650px;\n  letter-spacing: -0.5px;\n  text-align: left;\n  text-shadow: 0 0 10px rgba(255, 255, 255, 0.3),\n               0 0 20px rgba(255, 255, 255, 0.2),\n               0 0 30px rgba(255, 255, 255, 0.1);\n}\n\n.hero-subheading {\n  font-size: 1.8rem;\n  color: var(--secondary-color);\n  line-height: 1.5;\n  max-width: 550px;\n  font-weight: 500;\n  text-align: left;\n  margin-top: 1rem;\n}\n\n/* Button Styles */\n.hero-button {\n  background: linear-gradient(135deg, var(--secondary-color), var(--secondary-light));\n  color: var(--primary-dark);\n  font-size: 1.5rem;\n  font-weight: 700;\n  padding: 18px 36px;\n  border-radius: 9999px;\n  border: none;\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  animation: fadeSlideUp 0.5s ease forwards,\n             pulse 2s infinite;\n  opacity: 0;\n  box-shadow: 0 0 20px rgba(220, 202, 152, 0.3),\n              0 0 40px rgba(220, 202, 152, 0.1);\n  position: relative;\n  overflow: hidden;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.hero-button::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  left: -50%;\n  width: 200%;\n  height: 200%;\n  background: linear-gradient(\n    45deg,\n    transparent,\n    rgba(255, 255, 255, 0.3),\n    transparent\n  );\n  transform: rotate(45deg);\n  animation: shimmer 3s infinite;\n}\n\n.hero-button:hover {\n  background: linear-gradient(135deg, var(--secondary-light), var(--secondary-color));\n  transform: translateY(-3px) scale(1.05);\n  box-shadow: 0 0 30px rgba(220, 202, 152, 0.4),\n              0 0 60px rgba(220, 202, 152, 0.2);\n}\n\n.hero-button:active {\n  transform: translateY(1px) scale(0.98);\n}\n\n.arrow-icon {\n  margin-left: 12px;\n  font-size: 1.8rem;\n  transition: transform 0.3s ease;\n}\n\n.hero-button:hover .arrow-icon {\n  transform: translateX(5px);\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n    box-shadow: 0 0 20px rgba(220, 202, 152, 0.3),\n                0 0 40px rgba(220, 202, 152, 0.1);\n  }\n  50% {\n    transform: scale(1.03);\n    box-shadow: 0 0 25px rgba(220, 202, 152, 0.4),\n                0 0 50px rgba(220, 202, 152, 0.2);\n  }\n  100% {\n    transform: scale(1);\n    box-shadow: 0 0 20px rgba(220, 202, 152, 0.3),\n                0 0 40px rgba(220, 202, 152, 0.1);\n  }\n}\n\n@keyframes shimmer {\n  0% {\n    transform: translate(-50%, -50%) rotate(45deg);\n  }\n  100% {\n    transform: translate(150%, 150%) rotate(45deg);\n  }\n}\n\n/* Image Content */\n.hero-image-content {\n  position: relative;\n  height: 400px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  animation: fadeSlideUp 0.5s ease forwards;\n  animation-delay: 0.1s;\n  opacity: 0;\n  background-color: transparent;\n}\n\n.gradient-shape {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background: rgba(220, 202, 152, 0.15);\n  border-radius: 16px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  box-shadow: var(--shadow-lg);\n  backdrop-filter: blur(8px);\n  border: 1px solid rgba(220, 202, 152, 0.3);\n}\n\n.hero-svg {\n  width: 100%;\n  height: 100%;\n  color: rgba(220, 202, 152, 0.2);\n}\n\n/* Membership card container styles */\n.membership-card-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: auto;\n  background-color: transparent;\n}\n\n.membership-card-container .school-membership-card {\n  width: 100%;\n  margin-top: 0;\n  max-width: 100%;\n  box-shadow: var(--shadow-lg);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  animation: fadeIn 0.5s ease forwards;\n  animation-delay: 0.1s;\n}\n\n/* School Membership Card */\n.school-membership-card {\n  background: linear-gradient(135deg, rgba(42, 157, 143, 0.85), rgba(30, 110, 100, 0.85));\n  border-radius: 12px;\n  padding: 0 40px 40px 40px;\n  box-shadow: 0 8px 32px rgba(42, 157, 143, 0.3);\n  margin-top: 30px;\n  max-width: 550px;\n  animation: fadeSlideUp 0.5s ease forwards;\n  animation-delay: 0.3s;\n  opacity: 0;\n  border: 1px solid rgba(220, 202, 152, 0.3);\n  backdrop-filter: blur(8px);\n  position: relative;\n  overflow: hidden;\n}\n\n.school-membership-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 100%;\n  background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.1), transparent);\n  animation: shimmer 2s infinite;\n}\n\n.membership-title {\n  color: var(--secondary-color);\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 30px;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.membership-footer {\n  color: #e5d8b7;\n  font-size: 2.5rem;\n  font-weight: 700;\n  text-shadow: 0 0 10px rgba(255, 255, 255, 0.4),\n               0 0 20px rgba(255, 255, 255, 0.2),\n               0 0 30px rgba(255, 255, 255, 0.1);\n  text-align: center;\n  margin: 0 auto 0;\n  animation: glow 2s ease-in-out infinite alternate;\n}\n\n@keyframes glow {\n  from {\n    text-shadow: 0 0 10px rgba(255, 255, 255, 0.4),\n                 0 0 20px rgba(255, 255, 255, 0.2),\n                 0 0 30px rgba(255, 255, 255, 0.1);\n  }\n  to {\n    text-shadow: 0 0 20px rgba(255, 255, 255, 0.6),\n                 0 0 30px rgba(255, 255, 255, 0.4),\n                 0 0 40px rgba(255, 255, 255, 0.2);\n  }\n}\n\n.benefits-list {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n\n.benefit-item {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 24px;\n  font-size: 1.6rem;\n  color: white;\n  text-shadow: 0 0 10px rgba(255, 255, 255, 0.4),\n               0 0 20px rgba(255, 255, 255, 0.2);\n  position: relative;\n}\n\n.check-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  background-color: rgba(255, 255, 255, 0.25);\n  border-radius: 9999px;\n  color: white;\n  margin-right: 16px;\n  flex-shrink: 0;\n  font-size: 1.4rem;\n  box-shadow: 0 0 15px rgba(255, 255, 255, 0.2);\n}\n\n.benefit-text {\n  line-height: 1.5;\n  text-shadow: 0 0 10px rgba(255, 255, 255, 0.4),\n               0 0 20px rgba(255, 255, 255, 0.2);\n  transition: text-shadow 0.3s ease;\n  font-weight: 500;\n}\n\n.benefit-item:hover .benefit-text {\n  text-shadow: 0 0 15px rgba(255, 255, 255, 0.5),\n               0 0 25px rgba(255, 255, 255, 0.3);\n}\n\n/* Navigation Buttons */\n.nav-button {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 48px;\n  height: 48px;\n  background-color: rgba(220, 202, 152, 0.9);\n  border-radius: 9999px;\n  border: 1px solid rgba(220, 202, 152, 0.3);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-dark);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  z-index: 10;\n  box-shadow: var(--shadow-md);\n}\n\n.nav-button:hover {\n  background-color: var(--secondary-color);\n  transform: translateY(-50%) scale(1.05);\n  box-shadow: var(--shadow-lg);\n}\n\n.nav-button.prev {\n  left: 20px;\n}\n\n.nav-button.next {\n  right: 20px;\n}\n\n.nav-button svg {\n  width: 28px;\n  height: 28px;\n}\n\n/* Dots Navigation */\n.dots-container {\n  position: absolute;\n  bottom: 32px;\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  background-color: transparent;\n}\n\n.dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 9999px;\n  background-color: rgba(220, 202, 152, 0.3);\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.dot.active {\n  background-color: var(--secondary-color);\n  transform: scale(1.2);\n}\n\n/* Animations */\n@keyframes fadeSlideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* Limited Time Offer Styles */\n.limited-time-tag {\n  position: absolute;\n  top: 20px;\n  right: -35px;\n  background: var(--secondary-color);\n  color: var(--primary-color);\n  padding: 8px 40px;\n  transform: rotate(45deg);\n  font-weight: bold;\n  font-size: 0.9rem;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n  z-index: 1;\n}\n\n.original-price {\n  display: inline-block;\n  color: var(--secondary-color);\n  font-size: 1.2rem;\n  text-decoration: line-through;\n  opacity: 0.8;\n  margin-left: 8px;\n  position: relative;\n}\n\n.original-price::after {\n  display: none;\n}\n\n/* Responsive styles */\n@media (max-width: 1024px) {\n  .hero-heading {\n    font-size: 3rem;\n  }\n  \n  .hero-subheading {\n    font-size: 1.3rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .hero-grid {\n    grid-template-columns: 1fr;\n    grid-template-rows: auto auto;\n    gap: 20px;\n  }\n  .hero-image-content {\n    margin-top: 20px;\n  }\n  .membership-card-container {\n    max-width: 100%;\n    margin: 0 auto;\n  }\n  .membership-card-container .school-membership-card {\n    max-width: 100%;\n  }\n  .hero-heading {\n    font-size: 2.2rem;\n    max-width: 100%;\n  }\n  .hero-subheading {\n    font-size: 1.2rem;\n    max-width: 100%;\n  }\n  .hero-button {\n    padding: 18px 28px;\n    margin-bottom: 10px;\n    font-size: 1.1rem;\n  }\n  .school-membership-card {\n    padding: 20px;\n  }\n  .benefit-item {\n    padding: 8px 0;\n  }\n  .hero-slideshow {\n    height: 800px;\n    padding-top: 80px;\n  }\n  .slide {\n    padding-top: 80px;\n  }\n  .hero-slide {\n    align-items: flex-start;\n    padding-top: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
